<template>
  <div class="side-bar">
    <div class="side-bar__top">
      <router-link class="side-bar__logo-wrp flex-center" :to="vueRoutes.users">
        <img
          class="side-bar__logo"
          src="../../../../public/logo-m2rwa.svg"
          alt="LOGO"
        />
      </router-link>

      <NavBar />
    </div>

    <div class="side-bar__bot">
      <Footer />
    </div>
  </div>
</template>

<script>
import NavBar from '@/Vue/common/SideBar/NavBar';
import Footer from '@/Vue/common/SideBar/Footer';
import { vueRoutes } from '@/router/route-const';

export default {
  components: { NavBar, Footer },
  setup() {
    return { vueRoutes };
  },
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';
@import '../../../scss/mixins';

.side-bar {
  min-height: 100vh;
  width: 24rem;
  border-radius: 0 2rem 2rem 0;
  background-color: $sb-bg-color;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: fixed;

  &__logo {
    width: 160px;
    height: 160px;
    object-fit: contain;

    &-wrp {
      width: 100%;
      height: 18rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @include respond-to($tablet) {
    display: none;
  }
}
</style>
